var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f5831840ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7a3fd50494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 0.5625 L 23.710938 0.5625 L 23.710938 28.144531 L 7 28.144531 Z M 7 0.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9abba1671"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.4375 5 L 12 5 L 12 11 L 6.4375 11 Z M 6.4375 5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5831840ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfbf9",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a3fd50494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 10.226562 14.675781 L 11.800781 17.671875 C 9.828125 17.058594 8.777344 16.136719 10.226562 14.675781 Z M 23.570312 26.453125 L 17.957031 16.289062 C 17.949219 16.277344 17.9375 16.265625 17.929688 16.253906 L 15.125 10.90625 C 15.230469 9.253906 15.261719 3.269531 10.464844 0.707031 C 9.890625 0.398438 9.171875 0.601562 8.855469 1.160156 C 8.539062 1.714844 8.75 2.414062 9.324219 2.71875 C 12.785156 4.570312 12.835938 9.253906 12.769531 10.660156 C 12.511719 10.785156 10.078125 11.960938 9.878906 12.140625 C 7.847656 12.542969 4.289062 18.179688 11.589844 20.003906 L 10.5 20.972656 C 10.289062 21.164062 10.152344 21.421875 10.121094 21.695312 L 9.53125 26.867188 C 9.460938 27.496094 9.925781 28.066406 10.578125 28.136719 C 11.222656 28.207031 11.808594 27.753906 11.882812 27.121094 L 12.421875 22.378906 L 16.050781 19.15625 L 16.683594 18.839844 L 21.492188 27.535156 C 21.796875 28.09375 22.511719 28.308594 23.089844 28.007812 C 23.664062 27.707031 23.882812 27.011719 23.570312 26.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9abba1671)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 11.296875 8.035156 C 11.296875 9.300781 10.238281 10.332031 8.933594 10.332031 C 7.625 10.332031 6.566406 9.300781 6.566406 8.035156 C 6.566406 6.761719 7.625 5.734375 8.933594 5.734375 C 10.238281 5.734375 11.296875 6.761719 11.296875 8.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.65ae5b9a6a0201980d7905bdaaa871d0.svg";
export { ForwardRef as ReactComponent };